<template>
  <v-card
    width="100%"
    height="100%"
    min-height="100vh"
    tile
    flat
    class="text-center"
    id="page-allcafe"
  >

    <v-card-text class="pt-0">
      <v-row justify="center">
        <v-col cols="12" sm="12" xs="12" lg="10" xl="10">

          <v-row justify="center">
            <v-col cols="12">
              <v-row align="start" justify="center" v-if="filterShops !== null">
                <v-col
                  v-for="(shopItem,ins) in filterShops"
                  :key="ins"
                  class
                  cols="4"
                  sm="4"
                  md="3"
                  lg="2"
                  xl="2"
                >
                  <v-lazy
                    v-model="isActiveLazy"
                    :options="{
                        threshold: .5
                      }"
                    transition="fade-transition"
                  >
                    <v-hover v-slot:default="{ hover }" open-delay="100">
                      <v-card
                        tile
                        class="text-center"
                        :elevation="hover ? 16 : 2"
                        @click="slectShopFromAllCafe(shopItem)"
                      >
                        <v-row align="start" justify="center" class="ma-0 pa-0">
                          <v-img
                            :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+ shopItem.logo"
                            aspect-ratio="2.0"
                            class="white ma-2"
                            contain
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-row>

                        <v-row align="end" justify="center" class="fill-height ma-0">
                          <v-col class="pa-0">
                            <div class="mx-1 name-shop-img pb-1">{{shopItem.title }}</div>
                          </v-col>
                        </v-row>
                        <v-row align="end" justify="center" class="fill-height ma-0">
                          <v-col class="pa-0">
                            <div class="mx-1 empty-sale pb-1"></div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-hover>
                  </v-lazy>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <!--    </v-container> -->

    <SeoBlock
      :seotxt1="allPages.seo_text_1"
      :seotxt2="allPages.seo_text_2"
      :seogallery="allPages.seo_images"
    />
  </v-card>
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "vue-router";
import axios from "axios";
import SeoBlock from "@/components/SeoBlock";

Vue.use(Vuex);

export default {
  name: "AllCafe",
  components: {
    SeoBlock,
  },
  data() {
    return {
      fixed: false,
      tabsmod: "all",
      selectGrpId: 0,
      servCat: null,
      allCafe: null,

      isActiveLazy: false,
      filterShops: null,
    };
  },

  metaInfo: {
    title: "Кафе и Рестораны -",
  },
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },
    loadPathData: {
      get() {
        return this.$store.getters.getLoadPathData;
      },
    },
    currentShop: {
      get() {
        return this.$store.state.shops.currentShop;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setCurrentShop", val);
      },
    },
    cafe() {
      const vApp = this;
    },
    shops() {
      let allShops = this.$store.state.shops.shops;
      let filterOnly = allShops.filter((allI) => {
        return (
          !allI.category.includes("50") &&
          !allI.category.includes("43") &&
          !allI.category.includes("37")
        );
      });
      if(DEBUG) console.log("filterOnly :", filterOnly);
      return filterOnly;
    },
    categories: {
      get() {
        if(DEBUG) console.log(
          "this.$store.state.category :",
          this.$store.state.category.categories
        );
        return this.$store.state.category.categories;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateCategory", val);
      },
    },
    titleInnert: {
      get() {
        if(DEBUG) console.log(
          "this.$store.state.category :",
          this.$store.state.app.titleInner
        );
        return this.$store.state.app.titleInner;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setTitleInner", val);
      },
    },
    allPages: {
      get() {
        const vApp = this;
        let getAllPages = vApp.$store.getters.getAllPages;
        const slugPage = vApp.$route.path.slice(1);
        if(DEBUG) console.log("path slug :>> ", vApp.$route.path);
        if(DEBUG) console.log(" slugPage :>> ", slugPage);
        if(DEBUG) console.log(" getAllPages :>> ", getAllPages);
        if(DEBUG) console.log(
          "this.$store.getters.getAllPages :>> ",
          getAllPages.find((sp) => sp.slug === slugPage)
        );
        return getAllPages.find((sp) => sp.slug === slugPage);
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setAllPages", val);
      },
    },
  },
  methods: {
    sortArray(array, property, direction) {
      direction = direction || 1;
      array.sort(function compare(a, b) {
        let comparison = 0;
        if (a[property] > b[property]) {
          comparison = 1 * direction;
        } else if (a[property] < b[property]) {
          comparison = -1 * direction;
        }
        return comparison;
      });
      return array; // Chainable
    },
    slectShopFromAllCafe(nShop) {
      let vApp = this;
      if(DEBUG) console.log("nShop :", nShop);
      vApp.currentShop = nShop;
      vApp.$router.push("/" + vApp.loadPathData.mnuCafePath + "/" + nShop.slug);
    },

    selectCategory(numCat) {
      let vApp = this;
      if(DEBUG) console.log("Select numCat :", numCat);
      vApp.selectGrpId = numCat;
    },
  },

  mounted() {
    if(DEBUG) console.log("mounted All Shops ");
    let vApp = this;
    this.$nextTick(function () {
      if(DEBUG) console.log("mounted AllCafe");
      vApp.titleInnert = "РЕСТОРАНЫ И КАФЕ";
      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json",
      })
        .catch(function (error) {
          if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
          if(DEBUG) console.log("response dataAllShops =", response.data);
          vApp.$store.dispatch("loadShops", response.data);
        });
      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_categories_with_shops",
      })
        .catch(function (error) {
          if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
          if(DEBUG) console.log("response dataAll Category = ", response.data);

          vApp.$store.dispatch("updateCategory", response.data);

          vApp.filterShops = [...response.data[1].objects]
          vApp.filterShops = vApp.sortArray(vApp.filterShops, "title");
          if(DEBUG) console.log("arr3 :", vApp.allCafe);
        });

      let scrollEl = document.querySelector("#scrollT");
      scrollEl.scrollTo(0, 0);
    });
  },
};
</script>
<style  scope>
.name-shop-img {
  line-height: 1.1;
  min-height: 36px;
}

.ramka {
  width: 90%;
  height: 90%;
}
.empty-sale {
  min-height: 28px;
}
</style>